import React, { useMemo } from 'react';
import type { AssetPlan } from '#/graphql/types';
import RecordPreview from '#/common/components/RecordPreview';
import RecordPreviewSection from '#/common/components/RecordPreview/RecordPreviewSection';
import { assetPlanStatusItems } from '../../utils/constants';
import { fields, type AssetPlanSummaryRecord } from './fields';

export interface AssetPlanSummaryPreviewProps {
  assetPlan: Pick<AssetPlan, 'name' | 'startYear' | 'endYear' | 'status' | 'notes'>;
}

const EMPTY_VALUE = '-';

const statusLabelMap = Object.fromEntries(
  assetPlanStatusItems.map((item) => [item.key, item.label]),
) as Record<string, string>;

const AssetPlanSummaryPreview: React.FC<AssetPlanSummaryPreviewProps> = ({ assetPlan }) => {
  const record = useMemo<AssetPlanSummaryRecord>(
    () => ({
      name: assetPlan.name ?? null,
      startYear: assetPlan.startYear ?? null,
      endYear: assetPlan.endYear ?? null,
      draftStatus: assetPlan.status ? statusLabelMap[assetPlan.status] ?? assetPlan.status : null,
      notes: assetPlan.notes ?? null,
    }),
    [assetPlan],
  );

  return (
    <RecordPreviewSection>
      <RecordPreview record={record} fields={fields} emptyValue={EMPTY_VALUE} />
    </RecordPreviewSection>
  );
};

export default React.memo(AssetPlanSummaryPreview);
